const data = {
  email: "example@email.com",
  social: {
    youtube: "https://www.youtube.com/channel/UCLY7o2FVcEvEolCHQzj3OYw",
    instagram: "http://instagram.com/genesmachines.io",
    facebook: "http://facebook.com/genesmachines.io",
    twitter: "https://twitter.com/Genes_Machines",
    linkedin: "https://www.linkedin.com/company/genes-machines/",
  },
};

export default data;
